module.exports = __webpack_public_path__ + "img/portrait-079.a23fddbd.jpg";